"use client";

import { useState } from "react";
import { TriangleAlert } from "lucide-react";

const RECORDING_MODE_KEY = "fluxity:recording-mode";

function getRecordingMode() {
  if (typeof window === "undefined") return false;

  const params = new URLSearchParams(window.location.search);
  const value = params.get("recording") ?? params.get("video");

  if (value === "1" || value === "true") {
    window.localStorage.setItem(RECORDING_MODE_KEY, "1");
    return true;
  }

  if (value === "0" || value === "false") {
    window.localStorage.removeItem(RECORDING_MODE_KEY);
    return false;
  }

  return window.localStorage.getItem(RECORDING_MODE_KEY) === "1";
}

const isSandbox = process.env.NEXT_PUBLIC_FLUXITY_ENV === "sandbox";

export function SandboxBanner() {
  const [recordingMode] = useState(getRecordingMode);

  if (!isSandbox || recordingMode) return null;

  return (
    <div className="bg-warning/90 text-warning-foreground text-center text-xs font-medium py-1.5 px-4">
      <TriangleAlert className="size-3 inline-block mr-1.5 -mt-0.5" />
      Sandbox Environment — Data resets weekly
    </div>
  );
}
